module.exports = __webpack_public_path__ + "static/media/result-0-en.9ec053ab.png";